import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { id: "autofit-style" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_Header)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, null, {
        default: _withCtx(() => [
          _createVNode(_component_Footer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}